<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<h1 mat-dialog-title>{{title}}</h1>
<fab-loading-spinner color="primary" *ngIf="showSpinner" id="loading-spinner"></fab-loading-spinner>
<div mat-dialog-content id="popup-container">
  <form [formGroup]="attributeForm">
    <mat-form-field>
      <mat-label>Current Value</mat-label>
      <input matInput id="current-value" formControlName="currentValue" />
    </mat-form-field>
    <br>

    <mat-form-field>
      <mat-label>New Value</mat-label>
      <mat-hint>Required</mat-hint>
      <input matInput maxlength="{{maxLength}}"
             formControlName="newValue" id="new-value" />
      <mat-error *ngIf="attributeForm.get('newValue').hasError('required')">
        New value is <strong>required</strong>.
      </mat-error>
    </mat-form-field>
    <mat-hint *ngIf="title === 'Vehicle Types'">Please enter 'CAR', 'TRUCK' or 'ND'.</mat-hint>

    <br>

    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
      <button mat-flat-button id="preview-button" class="action-button" [disabled]="validateInput()"
              (click)="previewChanges()">
        Preview Change
      </button>
      <button mat-raised-button color="primary" class="action-button" id="commit-button" [disabled]="validateInput()"
              (click)="commitChanges()">
        Commit Change
      </button>
    </div>

  </form>

</div>
